import { render } from "./GoogleAds.vue?vue&type=template&id=ab5c8e02"
import script from "./GoogleAds.vue?vue&type=script&lang=js"
export * from "./GoogleAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__